import { render, staticRenderFns } from "./ProxyForm.vue?vue&type=template&id=6d2c2cb2&"
import script from "./ProxyForm.vue?vue&type=script&lang=js&"
export * from "./ProxyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports